import SidebarMenu from '@/components/SidebarMenu/SidebarMenu.vue'
import Navbar from '@/components/Navbar/Navbar.vue'
import { mapGetters } from "vuex"
import BlurBackground from "@/components/__new_ui_kit/BlurBackground/BlurBackground";

export default {
    name: 'MainLayout',
    components: {
        SidebarMenu,
        Navbar,
        BlurBackground
    },
    data() {
        return {
            flag: true
        }
    },
    mounted() {},
    computed: {
        ...mapGetters([
            'toggleSidebar',
            'isLoggedIn',
            'getWidth'
        ]),
        needBlur() {
            return this.getWidth <= 950 && !this.toggleSidebar
        }
    }

}
